import { SettingsCulqiDto, PaymentMethodsCulqiDto, OptionsCulqiDto, AppearanceCulqiDto, ClientCulqiDto, ConfigCulqiDto } from '../../dto'

export const DEFAULT_SETTINGS_CULQI: SettingsCulqiDto = {
    title: 'CIPTECH',
    currency: 'PEN',
    amount: 0,
    order: ''
};

export const DEFAULT_PAYMENT_METHODS_SORT: string[] = ['tarjeta', 'yape', 'bancaMovil', 'agente', 'billetera', 'cuotealo'];

export const DEFAULT_PAYMENT_METHODS_CULQI: PaymentMethodsCulqiDto = {
    tarjeta: false,
    yape: false,
    billetera: false,
    bancaMovil: false,
    agente: false,
    cuotealo: false
};

export const DEFAULT_PAYMENT_TARJETA_CULQI: PaymentMethodsCulqiDto = {
    ... DEFAULT_PAYMENT_METHODS_CULQI,
    tarjeta: true,
    yape: true
};

export const DEFAULT_PAYMENT_EFECT_CULQI: PaymentMethodsCulqiDto = {
    ... DEFAULT_PAYMENT_METHODS_CULQI,
    billetera: true,
    bancaMovil: true,
    agente: true,
    cuotealo: true
};

export const DEFAULT_CLIENT_CULQI: ClientCulqiDto = {
    email: null
};

export const DEFAULT_OPTIONS_CULQI: OptionsCulqiDto = {
    lang: 'es',
    installments: true, // Habilitar o deshabilitar el campo de cuotas
    modal: true,
    paymentMethods: DEFAULT_PAYMENT_METHODS_CULQI,
    paymentMethodsSort: DEFAULT_PAYMENT_METHODS_SORT
};

export const DEFAULT_OPTIONS_CULQI2: OptionsCulqiDto = {
    lang: 'es',
    installments: [3, 6, 12],
    modal: true,
    paymentMethods: DEFAULT_PAYMENT_METHODS_CULQI,
    paymentMethodsSort: DEFAULT_PAYMENT_METHODS_SORT
};

// https://docs.culqi.com/es/documentacion/checkout/checkout-custom#configuraci%C3%B3n-de-opciones-del-checkout
export const DEFAULT_APPEARANCE_CULQI: AppearanceCulqiDto = {
    theme: 'default',
    menuType: 'sidebar',
    buttonCardPayText: 'Pagar',
    logo: 'https://i.imgur.com/kq5PBRH.png',
    defaultStyle: {
        bannerColor: '#193b48'
    }
};

export const DEFAULT_CONFIG_CULQI: ConfigCulqiDto = {
    settings: DEFAULT_SETTINGS_CULQI,
    client: DEFAULT_CLIENT_CULQI,
    options: DEFAULT_OPTIONS_CULQI,
    appearance: DEFAULT_APPEARANCE_CULQI
};


